import Vue from 'vue'

export default {
  methods: {
    getMaxValue: function (config, numberOfItems) {
      if (!config) {
        return 1
      }
      return numberOfItems > 1 ? config.MultiMaxPayInAmount : config.SingleMaxPayInAmount
    },
    getMinValue: function (config, numberOfItems) {
      if (!config) {
        return 1
      }
      return numberOfItems > 1 ? config.MultiMinPayInAmount : config.SingleMinPayInAmount
    },
    extractHomeTeamName: function (match) {
      if (match && match.Matches && match.Matches.length > 0) {
        return match.Matches[0].HomeTeam
      }
      return ''
    },
    extractAwayTeamName: function (match) {
      if (match && match.Matches && match.Matches.length > 0) {
        return match.Matches[0].AwayTeam
      }
      return ''
    },
    addAdditionDataToMatch (match, matchId, isBetPlaced, isBettingEnabled, activeStake) {
      Vue.set(match, 'match', matchId)
      Vue.set(match, 'isBetPlaced', isBetPlaced)
      Vue.set(match, 'isBettingEnabled', isBettingEnabled)
      Vue.set(match, 'activeStake', activeStake)
      return match
    },
    getPreparedDataJackpot (data) {
      let fallenJackpots = {
        'showSlider': '',
        'ticketNo': '',
        'ticketLocation': '',
        'JackpotAmount': ''
      }
      let showFallenJackpots = false
      if (data) {
        if (data.JackpotName.includes('stadium') || data.JackpotName.includes('Stadium')) {
          fallenJackpots.showSlider = 'Stadium'
        } else if (data.JackpotName.includes('champion') || data.JackpotName.includes('Champion')) {
          fallenJackpots.showSlider = 'Champion'
        }
        fallenJackpots.ticketNo = data.Barcode
        fallenJackpots.ticketLocation = data.LocationName
        fallenJackpots.jackpotAmount = data.JackpotAmount
        showFallenJackpots = true
      }
      return {
        'fallenJackpots': fallenJackpots,
        'showFallenJackpots': showFallenJackpots
      }
    },
    preparedMaches: function (picks) {
      return picks.map(v => {
        let eventID = ''
        let stakeID = ''
        let type = ''
        if (v && v.EventID) {
          eventID = v.EventID
        }
        if (v && v.activeStake && v.activeStake['ID']) {
          stakeID = v.activeStake['ID']
        }
        if (v && v.activeStake) {
          type = this.getBettingType(v.activeStake)
        }
        return {
          'eventID': eventID,
          'stakeID': stakeID,
          'type': type
        }
      })
    },
    getBettingType (v) {
      if (v.TableName === 'full_time') {
        return this.$t('betType') + ` : FT ${v.Title}`
      } else if (v.TableName === 'half_time') {
        return this.$t('betType') + ` : HT ${v.Title}`
      } else if (v.TableName === 'sum_of_goals') {
        let isMoreTable = v.TableSubname === 'more'
        return this.$t('betType') + ` : ${isMoreTable ? 2 : 1} G(-${v.Title}+)`
      } else if (v.TableName === 'correct_score') {
        return this.$t('betType') + ` : Result ${v.Title}`
      }
    },
    inputClass (selected, status) {
      if (selected === '3') {
        if (status === 0) return 'single-ticket__danger'
        if (status === 1) return 'single-ticket__success'
        if (status === 2) return 'single-ticket__neutral'
      } else if (selected === '0') {
        if (status === 0) return 'single-ticket__danger'
        if (status === 1) return 'hide'
        if (status === 2) return 'hide'
        if (status === 2) return 'hide'
      } else if (selected === '1') {
        if (status === 0) return 'hide'
        if (status === 1) return 'single-ticket__success'
        if (status === 2) return 'hide'
      } else if (selected === '2') {
        if (status === 0) return 'hide'
        if (status === 1) return 'hide'
        if (status === 2) return 'single-ticket__neutral'
      }
    }
  }
}
